import { render } from "./BaseSegmentedControl.vue?vue&type=template&id=32404f18&scoped=true"
import script from "./BaseSegmentedControl.vue?vue&type=script&lang=js"
export * from "./BaseSegmentedControl.vue?vue&type=script&lang=js"

import "./BaseSegmentedControl.vue?vue&type=style&index=0&id=32404f18&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32404f18"]])

export default __exports__